class TreeFilter {
  constructor(specPaths) {
    // Преобразуем строки вида '1_2' → массивы ['1', '2']
    this.paths = specPaths.map((s) => s.split('_'));
  }

  run(data) {
    // Запускаем фильтрацию с нулевого уровня
    return this._filter(data, 0, [], this.paths);
  }

  _filter(data, level, path, specs) {
    return data
      .map((node) => {
        // Строим текущий путь по дереву
        const currentPath = [...path, node.groupValue];

        // Совпадение: есть ли точное соответствие хотя бы одной спецификации
        const matchesHere = specs.some(
          (spec) =>
            spec.length === currentPath.length &&
            spec.every((val, idx) => val === currentPath[idx])
        );

        // Нужно ли идти дальше по дереву?
        const shouldRecurse = specs.some(
          (spec) => spec.length > currentPath.length
        );

        // Если есть куда идти — фильтруем дочерние узлы
        const filteredChildren =
          shouldRecurse && node.children
            ? this._filter(node.children, level + 1, currentPath, specs)
            : undefined;

        // Возвращаем узел, если он подходит сам или у него есть подходящие дети
        return matchesHere || filteredChildren?.length > 0
          ? {
              ...node,
              ...(filteredChildren ? { children: filteredChildren } : {}),
            }
          : null;
      })
      .filter(Boolean); // удаляем пустые ветви
  }
}

export const createTreeFilter = (specPaths) => new TreeFilter(specPaths);
